import { render } from "./DestinationsManagement.vue?vue&type=template&id=ac400d2c"
import script from "./DestinationsManagement.vue?vue&type=script&lang=js"
export * from "./DestinationsManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__